import { Ng1StateDeclaration } from '@uirouter/angularjs';

const states: Ng1StateDeclaration[] = [
    {
        name: 'login',
        url: '/login',
        template: '<wt-login-page></wt-login-page>',
        params: {
            message: null
        },
        data: {
            visible: false,
            isAuthenticated: false,
            isConnected: false,
            icon: 'fa-sign-in',
            displayName: 'Login',
            editButtonVisibility: () => false
        }
    },
    // Most likely not used
    {
        name: 'backgroundLogin',
        url: '/backgroundLogin/:userName/:password/:applicationGuid/:environment/:model/?redirectUrl',
        template: '<div class="fill"><i class="fa fa-5x fa-windows"/></div>',
        controller: ($stateParams) => {},
        data: {
            visible: false,
            displayName: 'Background login',
            editButtonVisibility: () => false
        }
    },
    {
        name: 'entraId',
        url: '/entraId',
        abstract: false,
        component: 'wtEntraIdPage',
        data: {
            visible: false,
            isAuthenticated: false,
            isConnected: false,
            icon: 'fa-sign-in',
            displayName: 'Entra ID Login',
            editButtonVisibility: () => false
        }
    }
];

export default states;
